import { format } from 'owa-strings/utilities/format';
import { getSearchStore } from '../store/Store';
import { PeopleSuggestion } from '../store/schema/Suggestion';
import { SearchQuery } from 'mini-3s-service/lib/schema/SubstrateSearchRequest';
import { SubstrateEntityType } from 'mini-3s-service/lib/schema/SubstrateEntityType';
import { SubstrateKqlPrefix } from 'mini-3s-service/lib/schema/SubstrateKqlPrefix';

const OR_OPERATOR = '{0} OR {1}';
const KQL_SPECIFIER = '{0}:("{1}")';

/** Selector function which return the value of currentQuery from searchStore. */
export function getCurrentQuery() {
    return getSearchStore().currentQuery;
}

/**
 * Selector function which returns the Search Query object needed for 3S query call
 * @param prefix Kql prefix that needs to be appened in case of contact suggestion
 */
export function getSearchValueForQuery(
    prefix: SubstrateKqlPrefix = SubstrateKqlPrefix.NONE
): SearchQuery {
    const { currentQuery, selectedSuggestion } = getSearchStore();
    const isContactSuggestionSelected = selectedSuggestion?.Type === SubstrateEntityType.People;

    return isContactSuggestionSelected && prefix !== SubstrateKqlPrefix.NONE
        ? {
              QueryString: getKQLQueryString(selectedSuggestion as PeopleSuggestion, prefix),
              DisplayQueryString: '',
          }
        : {
              QueryString: currentQuery,
          };
}

/*
 * Internal helper function which forms the required KQL
 * Eg: from:("Collin Ballinger") OR from: ("collin@contoso.com") : from: ("collin.ballinger@contoso.com")
 */
function getKQLQueryString(suggestion: PeopleSuggestion, prefix: SubstrateKqlPrefix) {
    const initalQueryString = format(KQL_SPECIFIER, prefix, suggestion.DisplayName);
    const emailAddressMapper = (parsedQueryString: string, emailAddress: string) =>
        format(OR_OPERATOR, parsedQueryString, format(KQL_SPECIFIER, prefix, emailAddress));

    return (
        suggestion?.EmailAddresses?.reduce(emailAddressMapper, initalQueryString) ||
        suggestion.QueryText
    );
}
